import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import type { DialogProps as MuiV0DialogProps } from 'material-ui';
import { forwardRef } from 'react';

/**
 * This Component can be removed when all 'material-ui/Dialog' be removed
 */
const MUIV0DialogAdapter = forwardRef<
  MuiV0DialogProps['ref'],
  MuiV0DialogProps
>(
  (
    { open, actions, title, children, onRequestClose, className, contentStyle },
    ref
  ) => (
    <Dialog
      className={className}
      ref={ref}
      open={open}
      onClose={onRequestClose}
      PaperProps={{ style: contentStyle }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>{actions as React.ReactNode}</DialogActions>
    </Dialog>
  )
);

MUIV0DialogAdapter.displayName = 'MUIV0Dialog';

export default MUIV0DialogAdapter;
